import { render, staticRenderFns } from "./FilterDappFiltered.vue?vue&type=template&id=983f06be"
import script from "./FilterDappFiltered.vue?vue&type=script&lang=ts"
export * from "./FilterDappFiltered.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports